import React, { useCallback, useEffect, useMemo, useState } from "react";
import styles from "./LessonPreView.module.scss";
import FSBackIcon from "src/assets/icons/arrow_back.svg?react";
import Button from "@src/components/button/Button";
import LessonSidebar from "./LessonSidebar";
import SelectedContent from "@src/components/lesson-details/selected-content/SelectedContent";
// import { isHomeEDApp } from '@constants';
import { Section, SllLesson } from "@src/api/graphql-codegen";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import { useStandaloneContent } from "@src/hooks/useStandaloneContent";
import { useAnalytics, Events, useUser } from "@hooks";
import { mixpanelAccessProps } from "@src/utils/mixpanelAccess";
import { Tooltip } from "antd";
// import { Dropdown } from 'antd';
// import type { MenuProps } from 'antd';
import previewBar from "@src/assets/img/previewbar.svg?url";
import { LordIcon } from "@src/components/lord-icon/lord-icon";
import { IconInfo } from "@src/constants";
import SelectedNewLayoutContent from "@src/components/lesson-details/selected-content/SelectedNewLayoutContent";
import FSIcon from "@src/assets/icons/fullscreen.svg?react";
import { TranslationBadge } from "@src/components/translation-provider";

type Props = {
  lesson: SllLesson;
  onClose: () => void;
  onExit?: () => void;
  startLesson: (lesson: SllLesson) => void;
  startExercise?: (exercise: Section, isFromPreview?: boolean) => void;
  refetch?: (complete: boolean) => void;
  startShortClass?: (lesson: SllLesson, isFromPreview?: boolean) => void;
  openDetails?: (lesson: SllLesson) => void;
  isParentApp?: boolean;
  isMaterials?: boolean;
  isPlatformTower?: boolean;
  handleStartBegin?: () => void;
  handleResumeLesson?: () => void;
};

function LessonDetailComponent(props: Props) {
  const {
    lesson,
    onClose,
    startLesson,
    onExit,
    isParentApp,
    isMaterials,
    isPlatformTower,
    // handleStartBegin,
    // handleResumeLesson,
  } = props;
  // const [showBanner, setShowBanner] = useState(false)
  const {
    content: selectedContent,
    isPreview,
    setIsPreview,
    isNewLessonLayout,
    accessMethod,
  } = useStandaloneContent();

  const [showMenu, setShowMenu] = useState(false);
  // const [showResumeMenu, setShowResumeMenu] = useState(false)
  const [screenWidth, setScreenWidth] = useState(0);
  const [preview, setPreview] = useState(false);
  const [previewHover, setPreviewHover] = useState(false);
  const [needFullscreen, setNeedFullscreen] = useState(false);

  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(
      userAgent,
    );
  }, []);
  const isPhone = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const regexs = [
      /(Android)(.+)(Mobile)/i,
      /BlackBerry/i,
      /iPhone|iPod/i,
      /Opera Mini/i,
      /IEMobile/i,
    ];
    return regexs.some((b) => userAgent.match(b));
  }, []);

  const { trackEvent } = useAnalytics();
  const [user] = useUser();

  // const completedPercent = useMemo(() => {
  //   let percent = lesson?.progress ? lesson.progress : 0
  //   return percent
  // }, [lesson]);

  useEffect(() => {
    if (lesson) {
      // setShowBanner(true);
      setIsPreview(true);
      setPreview(true);
      trackEvent(Events.actions.standaloneLessonPreviewOpen, {
        lesson_name: lesson?.name,
        lesson_id: lesson?.id,
        ...mixpanelAccessProps(accessMethod),
        schoolId: user?.schools?.[0]?.id,
        schoolName: user?.schools?.[0]?.name,
        userId: user?.id,
        userName: `${user?.firstName} ${user?.lastName}`,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lesson?.id, user, setIsPreview]);

  useEffect(() => {
    const listener = () => {
      setTimeout(function () {
        const previewWrap = document.getElementById("previewWrapper");
        if (isPhone && previewWrap) {
          if (isPreview) {
            setPreview(previewWrap.clientHeight > previewWrap.clientWidth);
          }
          setScreenWidth(-previewWrap.clientWidth);
        } else {
          setScreenWidth(isTablet || isPhone ? -window.innerWidth : 0);
        }
      }, 100);
    };
    window.addEventListener("orientationchange", listener);

    listener();
    return () => {
      window.removeEventListener("orientationchange", listener);
    };
  }, [isTablet, isPhone, isPreview]);

  const handleMenu = useCallback(() => {
    if (isTablet || isPhone) {
      setShowMenu((current) => !current);
    } else {
      onClose();
    }
  }, [isTablet, isPhone, onClose]);

  const listStyle = useMemo(() => {
    if (isTablet || isPhone) {
      return styles.listMenu;
    } else {
      return styles.list;
    }
  }, [isTablet, isPhone]);

  const handleCloseMenu = () => {
    setShowMenu(false);
  };

  // const handleResumeDropdownVisible = useCallback((visible: boolean) => {
  //   setShowResumeMenu(visible)
  // }, []);

  // const handleResume = useCallback(() => {
  //   setShowResumeMenu(false);
  //   handleResumeLesson?.();
  // },[handleResumeLesson])

  // const handleStart = useCallback(() => {
  //   setShowResumeMenu(false);
  //   handleStartBegin?.();
  // },[handleStartBegin])

  // const items: MenuProps['items'] = [
  //   {
  //     key: '1',
  //     label: (
  //       <div className={styles.dropDownResumnMenuitem} onClick={handleResume}>
  //         <div className={styles.resumeMenuItem}>
  //           <div className={styles.resumeProgressBackBar}>
  //             <div className={styles.resumeProgressBar} style={{width: `${completedPercent}%`, backgroundColor: completedPercent === 100 ? "#62C590" : "#62C590", borderBottomRightRadius: completedPercent === 100 ? "3px" : "0" }}></div>
  //             <span className={styles.inprogressText}>Lesson in Progress</span>
  //           </div>
  //           <div className={styles.resumeText}>Resume Lesson</div>
  //         </div>
  //       </div>
  //     ),
  //   },
  //   {
  //     key: '2',
  //     label: (
  //       <div className={styles.dropDownMenuitem} onClick={handleStart}>
  //         Start from Beginning
  //       </div>
  //     ),
  //   }
  // ]

  const listSection = useMemo(
    () => (
      <div
        className={listStyle}
        style={{
          transform: showMenu
            ? "translateX(0)"
            : `translateX(${screenWidth}px)`,
          minWidth: isNewLessonLayout ? "" : 388,
          maxWidth: isNewLessonLayout ? 350 : "",
        }}
      >
        {(isTablet || isPhone) && showMenu && (
          <div className={styles.menuBar}>
            <button
              onClick={handleMenu}
              className={styles.menuButton}
              type={"button"}
            >
              <div className={styles.menuWrapper}>
                <CloseOutlined className={styles.burgerIcon} />
              </div>
            </button>
            <button
              onClick={onClose}
              className={styles.closeButton}
              type={"button"}
            >
              <div className={styles.menuWrapper}>
                <FSBackIcon className={styles.closeIcon} />
                {!isPhone && <div>Go Back</div>}
              </div>
            </button>
          </div>
        )}
        {!isMaterials && isPhone && (
          <div className={styles.mobileLandscapeCloseBar}>
            <button
              onClick={handleMenu}
              className={styles.landscapeCloseButton}
              type={"button"}
            >
              <div className={styles.menuWrapper}>
                <FSBackIcon className={styles.closeIcon} />
              </div>
            </button>
            <div className={styles.title}>{lesson.name}</div>
          </div>
        )}
        {isPhone ? (
          <div className={styles.moduleListView}>
            <div className={styles.moduleList}>
              <LessonSidebar
                lesson={lesson as SllLesson}
                closeNav={handleCloseMenu}
                startLesson={startLesson}
                isMaterials={isMaterials}
              />
            </div>
            <div className={styles.actions}>
              {/* {isMaterials && <Button label='BEGIN LESSON' size='small' className={styles.beginLesson} onClick={() => startLesson(lesson)}/>} */}
              <Button
                label="EXIT LESSON"
                size="small"
                className={styles.exitLesson}
                onClick={onClose}
              />
            </div>
          </div>
        ) : (
          <LessonSidebar
            lesson={lesson as SllLesson}
            closeNav={handleCloseMenu}
            startLesson={startLesson}
            isMaterials={isMaterials}
          />
        )}
      </div>
    ),
    [
      handleMenu,
      isTablet,
      lesson,
      listStyle,
      isNewLessonLayout,
      onClose,
      screenWidth,
      showMenu,
      startLesson,
      isMaterials,
      isPhone,
    ],
  );

  return (
    <div
      id="previewWrapper"
      className={`${styles.container} ${isPhone && !isMaterials ? styles.wholeContainer : ""}`}
    >
      {isPlatformTower ? (
        <div className={styles.platformTowerTitleView}>
          {(isTablet || isPhone) && (
            <button
              onClick={handleMenu}
              className={styles.platformTowerMenuButton}
              type={"button"}
            >
              <div className={styles.menuWrapper}>
                <MenuOutlined className={styles.burgerIcon} />
              </div>
            </button>
          )}
          <Tooltip
            placement="bottomLeft"
            title={<div className={styles.lessonTip}>Return to Dashboard</div>}
            arrowPointAtCenter
            color="#FFFFFF"
          >
            <button
              onClick={onClose}
              className={styles.platformTowerCloseButton}
              type={"button"}
            >
              <div className={styles.menuWrapper}>
                <FSBackIcon className={styles.platformTowerCloseIcon} />
              </div>
            </button>
          </Tooltip>
          <div className={styles.platformTowerTitle}>Platform Tour</div>
        </div>
      ) : (
        <div
          className={
            isPhone
              ? isMaterials
                ? styles.titleView
                : styles.mobileTitleView
              : styles.titleView
          }
        >
          {isTablet || isPhone ? (
            isPhone && showMenu ? (
              <button
                onClick={handleMenu}
                className={styles.closeButton}
                type={"button"}
              >
                <div className={styles.menuWrapper}>
                  <FSBackIcon className={styles.closeIcon} />
                </div>
              </button>
            ) : (
              <button
                onClick={handleMenu}
                className={styles.menuButton}
                type={"button"}
              >
                <div className={styles.menuWrapper}>
                  <MenuOutlined className={styles.burgerIcon} />
                </div>
              </button>
            )
          ) : null}
          {!isPhone && (
            <button
              onClick={onClose}
              className={styles.closeButton}
              type={"button"}
            >
              <div className={styles.menuWrapper}>
                <FSBackIcon className={styles.closeIcon} />
              </div>
            </button>
          )}
          <div className={styles.titleSubView}>
            {isMaterials ? (
              <>
                <div className={styles.title}>
                  {isPhone ? lesson.name : "Lesson Materials"}
                </div>
                {!(isTablet || isPhone) && (
                  <div className={styles.subMaterialTitle}>
                    Here you will find all the information and resources you
                    need to run this Lesson
                  </div>
                )}
              </>
            ) : isNewLessonLayout ? (
              <div className={styles.previewTitle}>{lesson.name}</div>
            ) : (
              <div className={styles.previewTitle}>Lesson Preview</div>
            )}
          </div>
          <div className={styles.buttons}>
            {isNewLessonLayout && (isTablet || isPhone) ? (
              <button
                onClick={() => {
                  setNeedFullscreen(true);
                }}
                className={styles.fullScreenButton}
                type={"button"}
              >
                <div className={styles.iconWrapper}>
                  <FSIcon />
                </div>
              </button>
            ) : null}
            {!user?.id?.toLowerCase().startsWith("au") && (
              <TranslationBadge type="preview" />
            )}
            {isNewLessonLayout && !(isTablet || isPhone) ? (
              <button
                onClick={() => {
                  setNeedFullscreen(true);
                }}
                className={styles.fullScreenButton}
                type={"button"}
              >
                <div className={styles.iconWrapper}>
                  <FSIcon />
                </div>
                <span className={styles.textWhite}>Open full screen</span>
              </button>
            ) : null}
          </div>
          {/* { (100 > completedPercent && completedPercent > 0)
        ? <Dropdown menu={{ items: items }} trigger={['click']} placement="bottom" onOpenChange={handleResumeDropdownVisible} open={showResumeMenu}>
            <Button size='small' label={'Begin Lesson'} className={styles.viewLesson} />
          </Dropdown>
        : !isParentApp && <Button label={'Begin Lesson'} color='white' className={styles.viewLesson} onClick={() => startLesson(lesson)} />
        } */}
        </div>
      )}
      <div
        className={isNewLessonLayout ? styles.newPage : styles.page}
        style={{ borderTop: isPlatformTower ? "none" : "1px solid #D8D8D8" }}
      >
        {(isTablet || isPhone) && showMenu && (
          <div
            className={styles.fsBackdrop}
            onClick={() => setShowMenu(false)}
          />
        )}
        {listSection}
        <div className={styles.content}>
          {!isNewLessonLayout && !isMaterials && !isPlatformTower && (
            <div className={styles.previewBanner}>
              <img src={previewBar} alt={"preview"} />
              <div className={styles.previewBar}>
                <span>PREVIEW</span>
                <div
                  className={styles.iconWrapper}
                  onMouseOver={() => setPreviewHover(true)}
                  onMouseLeave={() => setPreviewHover(false)}
                >
                  <LordIcon
                    src={IconInfo}
                    isHover={true}
                    colors={{ primary: "#FFFFFF", secondary: "#FFFFFF" }}
                    size={24}
                  />
                </div>
              </div>
            </div>
          )}
          {previewHover ? (
            <div className={styles.previewTooltip}>
              <strong>Note:&nbsp;</strong>“Preview” watermark is removed when
              you begin the Lesson
            </div>
          ) : null}
          {!isMaterials && isPhone && (
            <div className={styles.mobileLandscapeMenuBar}>
              <button
                onClick={handleMenu}
                className={styles.landscanpeMenuButton}
                type={"button"}
              >
                <MenuOutlined className={styles.landscapeBurgerIcon} />
              </button>
            </div>
          )}
          {/* {showBanner && isParentApp ? <div className={styles.preview}><strong>Note:&nbsp;</strong>{"“Preview” watermark is removed when you start the Lesson"}</div> : null} */}
          {selectedContent ? (
            isNewLessonLayout ? (
              <SelectedNewLayoutContent
                content={selectedContent}
                lesson={lesson}
                goBack={onClose}
                onExit={onExit}
                isPreview={preview}
                showBanner={false}
                isParentApp={isParentApp}
                startLesson={startLesson}
                needFullscreen={needFullscreen}
                closeFullScreen={() => {
                  setNeedFullscreen(false);
                }}
              />
            ) : (
              <SelectedContent
                content={selectedContent}
                lesson={lesson}
                goBack={onClose}
                onExit={onExit}
                isPreview={preview}
                showBanner={false}
                isParentApp={isParentApp}
                startLesson={startLesson}
              />
            )
          ) : null}
        </div>
      </div>
    </div>
  );
}

const LessonPreView = (props: Props) => {
  const {
    lesson,
    onClose,
    onExit,
    startLesson,
    isParentApp,
    refetch,
    startShortClass,
    startExercise,
    openDetails,
    isMaterials,
    isPlatformTower,
    handleStartBegin,
    handleResumeLesson,
  } = props;

  return (
    <LessonDetailComponent
      lesson={lesson}
      onClose={onClose}
      onExit={onExit}
      startLesson={startLesson}
      handleStartBegin={handleStartBegin}
      isParentApp={isParentApp}
      startExercise={startExercise}
      isMaterials={isMaterials}
      handleResumeLesson={handleResumeLesson}
      openDetails={openDetails}
      startShortClass={startShortClass}
      refetch={refetch}
      isPlatformTower={isPlatformTower}
    />
  );
};

export default LessonPreView;
